/**
 * Trouve l'épisode suivant dans une série
 * @param {Object} currentEpisode - L'épisode actuel
 * @param {Array} allMovies - Tous les films/épisodes disponibles
 * @returns {Object|null} - L'épisode suivant ou null si c'est le dernier
 */
export const findNextEpisode = (currentEpisode, allMovies) => {
    // Si ce n'est pas une série, retourner null
    if (!currentEpisode || currentEpisode.type !== 'serie' || !currentEpisode.episode) {
        return null;
    }

    // Récupérer tous les épisodes de la même série
    const seriesEpisodes = allMovies.filter(m =>
        m.type === 'serie' &&
        m.tmdbId === currentEpisode.tmdbId &&
        m.episode // Seulement les épisodes
    );

    if (seriesEpisodes.length === 0) return null;

    // Grouper par saison
    const episodesBySeason = seriesEpisodes.reduce((acc, episode) => {
        const season = episode.season || 1;
        if (!acc[season]) {
            acc[season] = [];
        }
        acc[season].push(episode);
        return acc;
    }, {});

    // Trier les épisodes dans chaque saison
    Object.keys(episodesBySeason).forEach(season => {
        episodesBySeason[season].sort((a, b) => a.episode - b.episode);
    });

    const currentSeason = currentEpisode.season || 1;
    const currentEpisodeNumber = currentEpisode.episode;

    // 1. Chercher l'épisode suivant dans la même saison
    const currentSeasonEpisodes = episodesBySeason[currentSeason] || [];
    const nextInSeason = currentSeasonEpisodes.find(ep => ep.episode === currentEpisodeNumber + 1);

    if (nextInSeason) {
        return nextInSeason;
    }

    // 2. Si pas d'épisode suivant dans la saison, chercher le premier épisode de la saison suivante
    const nextSeason = currentSeason + 1;
    const nextSeasonEpisodes = episodesBySeason[nextSeason];

    if (nextSeasonEpisodes && nextSeasonEpisodes.length > 0) {
        // Retourner le premier épisode de la saison suivante (trié)
        return nextSeasonEpisodes[0];
    }

    // 3. C'est le dernier épisode de la série
    return null;
};

/**
 * Vérifie si un épisode a un épisode suivant
 * @param {Object} currentEpisode - L'épisode actuel
 * @param {Array} allMovies - Tous les films/épisodes disponibles
 * @returns {boolean}
 */
export const hasNextEpisode = (currentEpisode, allMovies) => {
    return findNextEpisode(currentEpisode, allMovies) !== null;
};